module.exports = "/images/vendor/trumbowyg/dist/ui/icons.svg?03b409107d49a5506b1a8be3468ff0a0";